import { render, staticRenderFns } from "./RequestView.vue?vue&type=template&id=6956e55e&scoped=true&"
import script from "./RequestView.vue?vue&type=script&lang=js&"
export * from "./RequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6956e55e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6956e55e')) {
      api.createRecord('6956e55e', component.options)
    } else {
      api.reload('6956e55e', component.options)
    }
    module.hot.accept("./RequestView.vue?vue&type=template&id=6956e55e&scoped=true&", function () {
      api.rerender('6956e55e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/updowngrade/RequestView.vue"
export default component.exports